// extracted by mini-css-extract-plugin
export var discard = "_31-3";
export var muiTooltipTooltip = "_31-5";
export var notificationBar = "_31-2";
export var saveButtonHoverSlotWrapper = "_31-4";
export var show = "_31-1";
export var spacer = "_31-0";